// import axios from 'axios';
import React, { useState } from 'react';
import './InputData.styl';

function InputData_PM(props) {
  return (
    <div className="data-customization-external-geojson-form">

      <div className="data-customization-panel__input__container">
        <input
          type="text"
          value={props.dataURL_PM}
          onChange={e => props.setDataURL_PM(e.target.value)}
          className="data-customization-panel__input"
          placeholder={props.placeholder}
        />
      </div>
    
    </div>
  )
}
export default InputData_PM